export interface MarketingDataRow {
    cells: ReadonlyArray<string>;
}

/** A semantic, horizontally scrollable data table for marketing references. */
export function DataTable({
    caption,
    columns,
    rows,
}: {
    caption: string;
    columns: ReadonlyArray<string>;
    rows: ReadonlyArray<MarketingDataRow>;
}) {
    return (
        <div className="mktg-data-table-wrap">
            <table className="mktg-data-table">
                <caption>{caption}</caption>
                <thead><tr>{columns.map((column) => <th key={column} scope="col">{column}</th>)}</tr></thead>
                <tbody>
                    {rows.map((row) => <tr key={row.cells.join('|')}>{row.cells.map((cell, index) => <td key={`${index}-${cell}`}>{cell}</td>)}</tr>)}
                </tbody>
            </table>
        </div>
    );
}
